// ** Third Party Components
import styled from "styled-components";

// ** Styles Import
import { breakpoints } from "styles/grid";

// ** Custom Components
import Block from "components/layout/Block";

// ####################################################

export const StyledAttachmentDialogBlock = styled(Block)`
	display: flex;
	position: relative;
	flex-direction: column;
	height: 100%;
	padding-top: 1rem;
	padding-bottom: 1.5rem;
	align-items: center;
	justify-content: center;

	@media (max-width: ${breakpoints.phone - 1}px) {
		height: calc((var(--vh, 1vh) * 100) - 0.75rem);
		padding-top: 50px;
		padding-bottom: 0.75rem;
	}
`;

// ####################################################
